export default {
  tags: [],
  autocomplete_data : [],
  autocomplete_selected : {},
  tag:[],
  selected_tag : {},
  tag_status:[]
}
